module.exports = __webpack_public_path__ + "img/deco-par-theme.9292a7b.png";